<div *ngIf="!preview" class="link w-full flex justify-content-between mt-2">
  <span class="text-xl font-bold"
    >{{ 'widgets.userRoles.header' | translate }} ({{users.length}})</span
  >
  <span
    *ngIf="!editMode"
    [pTooltip]="'widgets.userRoles.link' | translate"
    (click)="viewAllUsers()"
    class="pi pi-window-maximize cursor-pointer text-primary mr-2"></span>
</div>

<div
  *ngIf="users && users.length > 0"
  appendTo="body"
  echarts
  [options]="options"
  class="chart"></div>
